import { setLocale } from 'monaco-editor/esm/vs/nls.js';
const extensionTranslationsUri = {};
function registerLocalization(language, main, extensionTranslationsUris) {
    setLocale(language, main);
    extensionTranslationsUri[language] = extensionTranslationsUris;
}
function getBuiltInExtensionTranslationsUris(language) {
    return extensionTranslationsUri[language];
}
export { getBuiltInExtensionTranslationsUris, registerLocalization };
